export const AddToGoogleCalendar = ({ data }) => {
  const originalDate = new Date(data.datetime); // assume it's UTC
  const endDate = new Date(originalDate.getTime() + 5 * 60 * 60 * 1000); // add 5 hours

  const formatToCalendar = (date) => {
    return date.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  };

  const startTime = formatToCalendar(originalDate); // 20250409T203300Z
  const endTime = formatToCalendar(endDate); // 20250410T013300Z


  const url = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
    `${data.bridesName}&${data.groomsName}-${data.location1.name}`
  )}&details=${encodeURIComponent(
    data.description
  )}&location=${encodeURIComponent(
    data.location1.title
  )}&dates=${startTime}/${endTime}`;

  return (
    <div className="flex justify-end py-10 px-5">
      <a href={url} target="_blank" rel="noopener noreferrer">
        <button className="bg-gray  px-4 py-2 rounded flex justify-center items-center gap-2">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Google_Calendar_icon_%282020%29.svg/1024px-Google_Calendar_icon_%282020%29.svg.png"
            alt="calender"
            className="h-5 w-5 object-contain"
          />
          <p>Add to Calendar</p>
        </button>
      </a>
    </div>
  );
};
